export const mutation_update_tenant = `
mutation updateTenant($tenantId: String!, $name: String!, $identifier: String!, $vatNumber: String!, $addrStreetName: String!, $addrStreetNumber: String!, $addrCity: String!, $addrProvince: String!, $addrZipCode: String!, $addrCountry: String!, $addrFull: String!, $classifier: String!) {
    update_tenant(where: {TenantId: {_eq: $tenantId}}, _set: {Name: $name, Identifier: $identifier, VatNumber: $vatNumber, AddrStreetName: $addrStreetName, AddrStreetNumber: $addrStreetNumber, AddrCity: $addrCity, AddrProvince: $addrProvince, AddrZipCode: $addrZipCode, AddrCountry: $addrCountry, AddrFull: $addrFull, Classifier: $classifier}) {
        returning {
            TenantId
            OwnerId
            Name
            Identifier
            IsReadOnly
            IsDisabled
            IsDeleted
            StatusDate
            VatNumber
            AddrStreetName
            AddrStreetNumber
            AddrCity
            AddrProvince
            AddrZipCode
            AddrCountry
            AddrFull
            Classifier
        }
    }
}`;